<div class="row">
  <div class="col-lg-12 col-sm-12 col-md-12 header-center">
    <table>
      <tr>
        <td>
          <img src="assets/images/PanadolLogo1x.png" class="header-logo" />
        </td>
        <td class="header-title">
          <strong>Paracetamol + Caffeine vs. Comparators</strong><br />The active ingredients in Panadol Extra
          (Paracetamol
          and caffeine) provides fast and effective pain relief for tough pain
        </td>
      </tr>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="table-container" style="width:100%;visibility: hidden;">
      <table style="width:100%;table-layout:fixed">
        <tr>
          <td style="width: 72px;vertical-align: top;position: relative;left: 4px;">
            <div class="row scrollable" style="display: flex;">
              <div class="left-header" style="z-index: 78;">
                <div class="bg-blue row-1"></div>
                <div class="bg-blue row-2" style="height:135px;">Placebo</div>
                <div class="bg-blue row-3" style="height:82px;">Standard<br /> Panadol/<br /> Paracetamol<br /> alone
                </div>
                <div class="bg-blue row-4" style="height:80px;">Ibuprofen</div>
                <div class="bg-blue row-5" style="height:80px;">Aspirin</div>
                <div class="bg-blue row-6" style="height:55px;">Naproxen</div>
              </div>
            </div>
          </td>
          <td style="vertical-align:top;">
            <!-- scrollable right side content -->
            <div class="right-side" style="width:100%;">
              <div class="top-header" style="table-layout:fixed;width:100%">
                <div class="row scrollable" style="display: flex;">
                  <div id="parent-div-2" class="column">
                    <div class="row-1">Headache <br />(Tension-type)</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Ward)">Ward, 1991;</a><br />
                        <a (click)="open(Rabello)">Rabello, 2000;</a><br />
                        <a (click)="open(Migliardi)">Migliardi, 1994;</a>
                      </strong>
                    </div>
                    <div class="bg-green table-text-color row-3">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Derry)">Derry, 2014;</a><br />
                        <a (click)="open(Laska)">Palmer, 2010;</a><br />
                        <a (click)="open(Migliardi)">Migliardi, 1994;</a>
                      </strong>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <strong><a (click)="open(Moore)">Moore, 2014</a></strong>
                    </div>
                    <div class="bg-green table-text-color row-5">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      (Wojcicki, 1977: <br />
                      post op headache)
                    </div>
                    <div class="row-6 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <strong><a (click)="open(Pini)">Pini, 2008</a></strong>
                    </div>
                  </div>

                  <div id="parent-div-3" class="column">
                    <div class="row-1">Migraine</div>
                    <div class="row-2 empty-div table-text-color">&nbsp;</div>
                    <div class="bg-green table-text-color row-3">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      Straube,2011
                    </div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>

                  <div id="parent-div-4" class="column">
                    <div class="row-1">Period/ <br />Menstrual pain</div>
                    <div class="row-2 empty-div table-text-color">&nbsp;</div>
                    <div class="bg-green table-text-color row-3">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Ali)">Ali, 2007;</a><br />
                        <a (click)="open(Ali)">A2370237;</a><br />
                        <a (click)="open(Derry)">Derry, 2014;</a><br />
                      </strong>Straube, 2011;<br />
                      <strong>
                        <a (click)="open(Laska)">Palmer, 2010;</a>
                      </strong>
                    </div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>

                  <div id="parent-div-5" class="column">
                    <div class="row-1">Musculoskeletal pain <br />(Strains/Sprains)</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      Wade, 1982 <br />
                      (Study with <br />
                      Paracetamol 1000 mg)
                    </div>
                    <div class="row-3 empty-div table-text-color">&nbsp;</div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>

                  <div id="parent-div-6" class="column">
                    <div class="row-1">Joint pain</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      Various guidelines <br />
                      recommend <br />
                      paracetamol as first line <br />
                      pharmacologic therapy <br />
                      for osteoarthritis. <br />
                      (Paracetamol monotherapy)
                    </div>
                    <div class="row-3 empty-div table-text-color">&nbsp;</div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>

                  <div id="parent-div-7" class="column">
                    <div class="row-1">
                      Dentalpain/post <br />
                      dental procedure/ <br />
                      tooth extraction
                    </div>
                    <div class="row-2 empty-div table-text-color">&nbsp;</div>
                    <div class="bg-green table-text-color row-3">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Derry)">Derry, 2014;</a><br />
                        <a (click)="open(Laska)">Palmer, 2010;</a><br />
                        <a (click)="open(Migliardi)">Migliardi, 1994;</a>
                      </strong>
                    </div>
                    <div class="bg-green table-text-color row-4">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Rashwan)">Rashwan, 2009</a>
                      </strong>
                    </div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>

                  <div id="parent-div-8" class="column">
                    <div class="row-1">Acute pain <br />(not specified)</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Laska)">Laska, 1984</a>
                      </strong>
                    </div>
                    <div class="bg-green table-text-color row-3">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Derry)">Derry, 2014</a>
                      </strong>
                    </div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>

                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<div class="row" style="margin-top:10px;">
  <div class="col-lg-7" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    <b>Instructions</b><br />
    Click on the study number or the author name to see the study details and summary.
  </div>
  <div class="col-lg-5">
    <div style="float: right;">
      <div class="legend-icon bg-green" (click)="active = 1" (mouseover)="active = 1" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 1">
          <img class="popup-panadol-green" />
        </div>
      </div>
      <div class="legend-icon bg-yellow" (click)="active = 2" (mouseover)="active = 2" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 2">
          <img class="popup-panadol-yellow" />
        </div>
      </div>
      <!-- <div class="legend-icon bg-pink" (click)="active = 3" (mouseover)="active = 3" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 3">
          <img class="popup-panadol-pink" />
        </div>
      </div> -->
      <div class="legend-icon bg-grey" (click)="active = 4" (mouseover)="active = 4" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 4">
          <img class="popup-panadol-grey" />
        </div>
      </div>
    </div>

  </div>
</div>


<ng-template #Ward let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra <strong>provides fast effective relief from<br />
          non-migranious headache</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td style="padding-left: 10px;vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  Double-blind placebo-controlled multiple crossover design
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td style="padding-left: 10px;vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  53 adults with non-migrainous headaches were given placebo, acetaminophen, 2 doses of caffeine
                  and 2 combinations of caffeine with acetaminophen.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;font-weight:bold">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td style="padding-left: 10px;vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  The combination of acetaminophen 648 mg and 130 mg of caffeine demonstrated statistically significant
                  reductions in visual analog pain score at the 30 min, 1 hour (h) and 2 h time points in comparison to
                  placebo.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;font-weight:bold">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td style="padding-left: 10px;vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  Within 2 h the combination also demonstrated statistically significant improvement in vigor, fatigue
                  and
                  depression compared to placebo
                </p>
              </td>
            </tr>
          </table>

        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Ward N. Pain 1991; 44:151-155.
    </p>
  </div>
</ng-template>

<ng-template #Rabello let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra <strong>provides fast effective relief from<br />
          non-migranious headache</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  Brazilian study included 5,490 patients with ~95% of the subjects had episodic TTH,
                  while 5% had chronic TTH.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  The majority of the patients presented with crisis of moderate intensity (62.19%).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  In 5,419 patients a TTH crisis was treated with acetaminophen 1000 mg and caffeine 130 mg.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;font-weight:bold">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  In 93.98%, onset of relief occurred within 2 hours of taking the medication.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;font-weight:bold">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  In 77.61%, complete reversion of the crisis occurred within 2 hours.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;font-weight:bold">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 8px;">
                  Good/excellent efficacy ratings were achieved in 61.93%/37.80% of the cases according to
                  the physician’s assessment
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Rabello GD, Forte LV, and Galvao ACR. Arq Neurosiquiatr 2000;58(1):90-98.
    </p>
  </div>
</ng-template>

<ng-template #Migliardi let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra effective <strong>in tension type headache</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Six randomized, double-blind, two-period crossover studies, conducted under similar protocols,
                  compared the
                  efficacy of two analgesic combinations containing caffeine with an acetaminophen 1000 mg control and
                  with a
                  placebo in outpatients with episodic tension-type headaches.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  In four studies, comprising 1900 patients, the caffeine-containing analgesic consisted of a
                  combination of 500 mg
                  acetaminophen, 500 mg aspirin, and 130 mg caffeine (APAP/ASA/CAF).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  In two studies, comprising 911 patients, the caffeine-containing analgesic consisted of a combination
                  of 1000 mg
                  acetaminophen and 130 mg caffeine (APAP/CAF).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Patients self-medicated for moderate or severe headache pain, and with a self-rating record they rated
                  their pain
                  and its relief hourly for 4 hours.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •
                </p>
              </td>
              <td class="container-fluid" style="padding-left: 10px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  In all six studies, the caffeine-containing analgesics were significantly superior both to placebo and
                  to 1000 mg
                  acetaminophen, and acetaminophen was significantly superior to placebo.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Migliardi JR <i>et al.</i> Caffeine as an analgesic adjuvant in tension headache. Clin Pharmacol Ther 1994;
      56:576-586.
    </p>
  </div>
</ng-template>

<ng-template #Laska let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra <strong>provides up to 37% more powerful<br />
          pain relief vs. standard paracetamol in acute pain<sup>1</sup></strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;text-align: center;">
      <img src="assets/images/panadol-extra/laska.png" style="width:75%;height:auto" />
    </div>
    <div class="container" style="padding-left: 0px;">
      <p style="font-family: OpenSansRegular;font-size: 10px;color: #124982;line-height: 12px;padding-top: 10px;">*Based on
        pooled relative
        potency estimate over the dose range of 500-1500 mg. Includes post-partum, headache, and dental extraction pain
        studies.</p>
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 14px;">
          A meta-analysis of eight clinical studies reported a small but significant adjuvant analgesic effect of
          130 mg caffeine when combined with 1,000 mg of paracetamol in the acute pain setting when compared with
          paracetamol alone<br /> (risk benefit 1.12; 95% confidence interval: 1.105-1.19; p&lt;0.0004), with no
          clinically
          meaningful
          increase in hepatotoxicity.<sup>2</sup>

        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      1. Laska EM, <i>et al</i>. Caffeine as an analgesic adjuvant. JAMA 1984; 251(13):1711-8.<br />
      2. Palmer H <i>et al</i>. Pain Medicine 2010;11:951-965.
    </p>
  </div>
</ng-template>


<ng-template #Derry let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>A Cochrane Review showed a beneficial</strong><br />
        analgesic effect of adjuvant caffeine
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;padding-top: 15px;">
      <div class="row" style="margin-bottom:20px;">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;font-weight:bold">
          Cochrane Review of 20 studies (n=7238) to assess the relative efficacy of a single dose of an analgesic plus
          caffeine against the same dose of the analgesic alone

        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-5 colxl-4 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
          <p>
            "The addition of caffeine (&#8805; 100 mg) to
            a standard dose of commonly used
            analgesics provides a small but important
            increase in the proportion of participants
            who experience a good level of pain relief"
          </p>
          <p>
            Most common pain conditions studied
            were postoperative dental pain, postpartum
            pain, and headache
          </p>
          <p style="font-weight:bold;">
            The active ingredients in Panadol Extra
            is Paracetamol and Caffeine
          </p>
        </div>
        <div class="col-lg-8 col-md-7 colxl-8 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
          <div>
            <img class="img-fluid" src="assets/images/panadol-extra/page-28_ax-2x.png">
          </div>
          <div>
            <table>
              <tr>
                <td>
                  <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-top: 5px;margin-bottom: 0px;">
                    Forest Plot of analgesics plus caffeine versus analgesic alone
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Derry CJ, Derry S, Moore RA. <i>Cochrane Database Syst Rev.</i> 2014 Dec 11;2014(12):CD009281.
    </p>
  </div>
</ng-template>


<ng-template #Ali let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra provides <strong>significantly more pain relief vs.
          standard Panadol in moderate-to-severe dysmenorrhea
          (period pain)</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">

      <div class="row">
        <div class="col-lg-6 col-md-5 colxl-4 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
          <p style="margin-bottom: 8px;">
            Single-dose, placebo-controlled, double blind, three-way
            crossover, outpatient study carried out in 320 women
            with moderate-to-severe dysmenorrhea pain
          </p>
          <p style="font-weight:bold;margin-bottom: 8px;">
            Results
          </p>
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  Two tablets of Panadol Extra provides significantly more
                  pain relief than standard Panadol (p&lt;0.05), 130 mg
                  caffeine or placebo (p&lt;0.01 for both)
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  Panadol Extra was also significantly more effective in
                  relieving abdominal cramping and backache
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  No major treatment related adverse events were reported
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-7 colxl-8 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 11px;color: #124982;line-height: 18px;">
          Significant pain relief with Panadol Extra lasts for up to 6 hours
          <table>
            <tr>
              <td>
                <table style="border:1px solid #124982">
                  <tr>
                    <td>
                      <img class="img-fluid" src="assets/images/panadol/significat6hr.png">
                    </td>
                  </tr>
                </table>
              </td>

            </tr>
          </table>
        </div>
      </div>
      <div class="row" style="margin-bottom:40px;">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;font-weight:bold">
          When taken at recommended doses, both paracetamol and the combination of paracetamol and caffeine are safe and
          effective treatments for
          primary dysmenorrhoea

        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Ali Z et al. <i>Current Medical Research and Opinion</i> 2007;23(4):841-851. <br />
      Single-dose Panadol Extra efficacy study A2370237.
    </p>
  </div>
</ng-template>

<ng-template #Moore let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>Panadol vs. Ibuprofen</strong> in tension type headache
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">

      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
          <p style="font-size:15px;font-weight:bold;">
            Efficacy of Panadol and ibuprofen in tension-type headache does not differ
          </p>
          <table>
            <tr>
              <!-- <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 12px;">
                  1.
                </p>
              </td> -->
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 12px;">
                  Indirect comparison of data from randomised studies of Panadol 1000 mg and Ibuprofen 400 mg
                </p>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol/pop2.png" />
              </td>
            </tr>
          </table>
          <!-- <table>
            <tr>
              <td style="vertical-align: top;">

              </td>
              <td class="container-fluid" style="text-align:center;">
                <p style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 14px;">
                  Drugs with dose in milligrams. Size of study arm is proportional to the size of the symbol (inset
                  scale).
                </p>
              </td>
            </tr>


          </table> -->
        </div>

      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Moore RA et al. <i>Pain</i> 2014;155:2220-2228
    </p>
  </div>
</ng-template>

<ng-template #Pini let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra<strong> is as efficacious as NSAIDs (naproxen) in treating headaches including tension type
          headache<sup>1</sup></strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 20px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row" style="padding-bottom: 0px;">
        <div class="col-lg-6 col-md-6 col-sm-12" style="text-align: center;">
          <img class="img-fluid" src="assets/images/panadol-extra/pop1ax.svg" style="padding-bottom: 15px;height: 240px;width: auto;">
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img class="img-fluid" src="assets/images/panadol-extra/pop2ax.svg">
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
          <p style="font-size:12px;">
            Study design: double-blind, randomized study of acute headache relief with paracetamol 1000mg + caffeine
            130mg
            or naproxen sodium 550mg (n=99). Pain relief was assessed using the 5-point total pain relief (TOTPAR) scale
            (0 = no relief, 4 = complete relief). The primary outcome was the noninferiority of paracetamol + caffeine
            vs
            naproxen
            in number of adverse events over 4 hours. Efficacy was assessed as a secondary outcome.<sup>1</sup>
          </p>

        </div>

      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      1. Pini LA et al J Headache Pain 2008; 9(6):367-73 <br />
      2. Martina et al: Nonprescription drugs recommended in guidelines for common pain conditions; Pain Manag 2019
    </p>
  </div>
</ng-template>

<ng-template #Rashwan let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra<strong>
          showed statistically significantly lower
          mean pain scores than the ibuprofen at 1 and 2 h after
          periodontal surgery
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">

      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
          <p style="font-size:12px;">
            Prospective randomised control trial comparing alternative therapies of Paracetamol 500 mg + caffeine,
            30 mg (PCF) & ibuprofen, 400 mg, in pain management immediately & after 8H of periodontal surgery
          </p>

        </div>

      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img class="img-fluid" src="assets/images/panadol-extra/pop3aa.png"><br />
          <p style="font-size:12px;color: #124982;line-height: 14px;">
            Numeric rating scale NRS 101 PCF showed statistically significantly
            lower mean pain scores than the IBU group at 1 and 2 h, whereas at
            6,7, and 8 h the IBU group showed statistically significantly lower
            pain scores (p &lt;0.001).
          </p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img class="img-fluid" src="assets/images/panadol-extra/pop4aa.png"><br />
          <p style="font-size:12px;color: #124982;line-height: 14px;">
            Shows the % of patients rating the pain using verbal rating scale.
            Both treatments were comparable in reducing pain.
          </p>
        </div>
      </div>
      <div class="row">
        <div col="col-lg-12 col-md-12 col-sm-12"
          style="font-size:12px;line-height: 14px; font-weight:bold;color:#124982;">
          Panadol Extra combination can be an effective option for patients with gastric ulcers or bleeding tendency
          because paracetamol better
          suitability in comparison to NSAIDs
        </div>
        <div col="col-lg-12 col-md-12 col-sm-12"
          style="font-size:14px;font-style:italic;color:#124982;margin-top: 8px;">
          The dose of paracetamol + caffeine used in this study is lower than contained in Panadol Extra
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Rashwan, et al J Periodontol. 2009
    </p>
  </div>
</ng-template>
